module.exports = __webpack_public_path__ + "static/media/app-store.49bc8a09.svg";